import PrintProductDiscountAlert from './PrintProductDiscountAlert';

export default PrintProductDiscountAlert;
